// Vendors
import React, { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { ErrorBoundaryProvider } from '@kubit/web-ui-components';
// Components
import EntrypointAuthorizationComponent from './components/authorization/entrypoint-authorization.component';
import { SuspenseLoaderComponent } from 'components/suspense-loader/suspense-loader.component';
// Contexts
import { AppContextProvider } from 'contexts/app.context';
import { FetchErrorContextProvider } from 'contexts/fetch-error/fetch-error.context';
import { ManagerContextProvider } from 'contexts/manager.context';
import { QuickActionsContextProvider } from 'contexts/quick-actions/quick-actions.context';
import { ToastContextProvider } from 'contexts/toast.context';
import { DownloadAppSKModalProvider } from 'contexts/download-app-sk-modal/download-app-sk-modal.provider';
import { BiometricProvider } from 'contexts/biometric/biometric.context';
// Providers
import { CaptchaProvider } from 'contexts/captcha/captcha.context';
import { ErrorProvider } from 'providers/error/error.provider';
import { IncreaseLimitHybridProvider } from 'providers/increase-limit-hybrid/increase-limit-hybrid.provider';
import { DownloadAppModalProvider } from 'providers/download-app-modal/download-app-modal.provider';
import ParallelLoadProvider from 'providers/parallel-load/parallel-load.provider';

const EntrypointCommon = (): React.ReactElement => (
  <ErrorBoundary FallbackComponent={ErrorProvider}>
    <ErrorBoundaryProvider>
      <BiometricProvider>
        <ManagerContextProvider>
          <AppContextProvider>
            <ToastContextProvider>
              <QuickActionsContextProvider>
                <FetchErrorContextProvider>
                  <IncreaseLimitHybridProvider>
                    <ParallelLoadProvider>
                      <DownloadAppModalProvider>
                        <DownloadAppSKModalProvider>
                          <CaptchaProvider>
                            <Suspense fallback={<SuspenseLoaderComponent />}>
                              <EntrypointAuthorizationComponent />
                            </Suspense>
                          </CaptchaProvider>
                        </DownloadAppSKModalProvider>
                      </DownloadAppModalProvider>
                    </ParallelLoadProvider>
                  </IncreaseLimitHybridProvider>
                </FetchErrorContextProvider>
              </QuickActionsContextProvider>
            </ToastContextProvider>
          </AppContextProvider>
        </ManagerContextProvider>
      </BiometricProvider>
    </ErrorBoundaryProvider>
  </ErrorBoundary>
);

export default EntrypointCommon;
